// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-url-icon svg[data-v-3e21c5e4] {\n  font-size: 60px;\n}\n.show-url[data-v-3e21c5e4] {\n  font-size: 1.1rem;\n}\n.collapsed > .when-open[data-v-3e21c5e4],\n.not-collapsed > .when-closed[data-v-3e21c5e4] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
